<template>
  <div v-if="resultado" class="row mt-3">
    <div v-if="resultado.data" class="col-12">
      <div class="list-group">
        <div class="list-group-item flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h3 class="mb-1">Diário Nª {{ resultado.data.dia_numero | padDigits }}</h3>
            <small class="text-muted">{{ resultado.data.dia_downloads + ' downloads' }}</small>
          </div>
          <p class="mb-1">{{ resultado.data.dia_data_publicacao | dateExtensao }}</p>
          <router-link target="_blank" ref="link" class="btn btn-outline-secondary btn-sm"
                       :to="{name: 'diario', params: { dia_numero: resultado.data.dia_numero }}">
            Diário em detalhe
          </router-link>
          <base-button outline type="secondary" @click="dowload(resultado.data)" size="sm">Baixar PDF
          </base-button>
          <base-button outline type="secondary" @click="dowload(resultado.data, 'HTML')" size="sm">Baixar HTML
          </base-button>
          <base-button v-if="!entidade.ent_diario_html" outline type="secondary" @click="dowload(resultado.data, 'ZIP')"
                       size="sm">Baixar todas as
            publicações
          </base-button>
        </div>
      </div>
    </div>
    <div v-if="!resultado.data" class="col-md-12">
      Sua pesquisa não encontrou nenhuma edição correspondente.
      <br>Sugestões:
      <ul class="ml-4">
        <li>Certifique-se de que o número da edição esteja escrito corretamente.</li>
        <li>Tente edições diferentes.</li>
      </ul>
    </div>
  </div>
</template>
<script>
import {dowloadDiario} from "@/plugins/webdom";

export default {
  name: 'edicao-resultado',
  props: {
    resultado: {
      type: Object,
    }
  },
  data() {
    return {}
  },
  methods: {
    dowload(diario, tipo = 'PDF') {
      dowloadDiario(diario, tipo)
    }
  },
  computed: {
    entidade() {
      return this.$store.getters.entidade;
    }
  }
}
</script>
<style>
</style>
